import {
  Space,
  Row,
  Col,
  Button,
  Table,
  Typography,
  Divider,
  Popover,
  message,
  Form,
} from "antd";
import React, {useEffect, useState} from "react";
import {InputFields} from "components/common";
import Icons from "assets/icons";
import {inputFields as inputFieldsInit, allColumns} from "./config";
import {ColumnProps} from "types/models";
import {pharmacyStoreService, storeService} from "api";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {getSuppliesStoreAPI} from "redux/reducer/medicalSupplies";
import Notification from "components/common/notification/notification";
import {getListStore} from "redux/reducer/pharmacyStore";

const Report = () => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const khoUserId = JSON.parse(localStorage.getItem("khoUserId"));
  // const listStore = useAppSelector((state) => state.pharmacyStore.listStore);
  const listStore = useAppSelector(state => state.pharmacyStore.listStore);

  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState();
  const [columns, setColumns] = useState<ColumnProps[]>(
    allColumns.filter(e => e.show == true)
  );

  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
    khoId: khoUserId ?? null,
  });

  useEffect(() => {
    if (khoUserId != null) {
      form.setFieldValue("khoId", khoUserId);
    }
  }, [khoUserId]);

  useEffect(() => {
    dispatch(getListStore());
    // getListStore();
    getListThuoc();
  }, []);

  useEffect(() => {
    getListReport();
  }, [params]);
  useEffect(() => {
    setOptionsSearchFields(listStore, "khoId");
  }, [listStore]);

  const setOptionsSearchFields = (list, name) => {
    if (inputFieldsInit.find(field => field.name === name)) {
      inputFieldsInit.find(field => field.name === name).options = list?.map(
        item => ({
          value: item.id,
          label: item.name,
        })
      );
    }
  };
  const getListThuoc = async () => {
    try {
      const res = (await storeService.getListMedicineByParams({})) || [];
      inputFieldsInit.find(e => e.name == "tenThuoc").options = res.map(e => {
        return {value: e?.name, label: e?.name};
      });
    } catch (error) {}
  };
  const onChangePagination = (page, pageSize) => {
    setParams({...params, page: page, limit: pageSize});
  };

  const getListReport = async () => {
    setLoading(true);
    try {
      const res = await pharmacyStoreService.getThongKeThuoc(params);
      setData(res.content);
      setTotal(res.totalElements);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi lấy danh sách thống kê thuốc");
    }
  };

  const onClickSearch = () => {
    const formValue = form.getFieldsValue();
    setParams({...params, ...formValue, page: 1});
  };
  const onKeyDown = e => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  return (
    <div className="medicine-container" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="container">
        <Form form={form}>
          <Row gutter={[16, 8]}>
            {inputFieldsInit && <InputFields data={inputFieldsInit} />}
          </Row>
          <Row justify={"end"} style={{marginTop: 12}}>
            <Space>
              <Button
                className="btn-sub"
                icon={<Icons.reload />}
                onClick={() => {
                  form.resetFields();
                }}
              >
                Xoá tìm kiếm
              </Button>
              <Button
                icon={<Icons.search />}
                type="primary"
                onClick={onClickSearch}
              >
                Tìm kiếm
              </Button>
            </Space>
          </Row>
        </Form>
      </div>
      <div className="container">
        <Space style={{width: "100%"}} direction="vertical">
          <Typography.Text strong>
            Danh sách tổng hợp số lượng thuốc
          </Typography.Text>
          <Divider type="horizontal" style={{margin: "0"}} />

          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              total: total,
              onChange: onChangePagination,
            }}
            bordered={true}
            // scroll={{x: 1000}}
          />
        </Space>
      </div>
    </div>
  );
};

export default Report;
